import DoneCircleIcon from "#/assets/descriptiveQuestion/done-circle.svg?url";
import FailedCircleIcon from "#/assets/descriptiveQuestion/failed-circle.svg?url";
import OutlinedCircleIcon from "#/assets/descriptiveQuestion/outlined-circle.svg?url";
import { useSelectedStudentIdContext } from "#/components/exam-results/context/studentsList/context";
import { MathJaxContent } from "#/components/mathjax";
import clsx from "clsx";
import DOMPurify from "dompurify";
import { useCallback } from "react";
import type { DqGlobalProps } from "../types";
import { useGetQuestions } from "../utils";
import styles from "./dqBody.module.scss";

type TOptions = {
  choiceId: string;
  value: string;
};

export const ReadOnlyOptions = (props: DqGlobalProps) => {
  const { id } = props;
  const { selectedStudentId } = useSelectedStudentIdContext();

  const {
    choiceDescription1,
    choiceDescription2,
    choiceDescription3,
    choiceDescription4,
    choicesColumnNo,
    answerId,
    selectedChoiceId,
    choiceId1,
    choiceId2,
    choiceId3,
    choiceId4,
  } = useGetQuestions(selectedStudentId, id)[0];

  const columnCategory = {
    "1": "one",
    "2": "two",
    "4": "four",
  }[String(choicesColumnNo)];

  const options: TOptions[] = [
    {
      choiceId: choiceId1,
      value: choiceDescription1 ?? "",
    },
    {
      choiceId: choiceId2,
      value: choiceDescription2 ?? "",
    },
    {
      choiceId: choiceId3,
      value: choiceDescription3 ?? "",
    },
    {
      choiceId: choiceId4,
      value: choiceDescription4 ?? "",
    },
  ];

  const getOptionIcon = useCallback(
    (option: TOptions) => {
      if (answerId === option.choiceId) {
        return DoneCircleIcon;
      } else if (selectedChoiceId === option.choiceId) {
        return FailedCircleIcon;
      }

      return OutlinedCircleIcon;
    },
    [answerId, selectedChoiceId],
  );

  if (!choicesColumnNo) return;

  return (
    <div
      className={clsx(
        styles["dq-body__options-container"],
        columnCategory && styles[`dq-body__${columnCategory}`],
      )}
    >
      {options.map((option, optionIndex) => (
        <div
          key={option.choiceId}
          className={styles["dq-body__options-container__option"]}
        >
          <div className={styles["dq-body__options-container__option__single"]}>
            <img
              src={getOptionIcon(option)}
              alt={`گزینه ${optionIndex + 1}`}
              height={16}
              width={16}
            />
            <span>{optionIndex + 1}</span>
          </div>
          <MathJaxContent value={DOMPurify.sanitize(option.value)} />
        </div>
      ))}
    </div>
  );
};
